import { BotMappieDialog } from '@/domain/bot-mappie';

/**
 * Extracts missing handles from module handlers in a dialog
 * @param dialog - The bot dialog containing modules
 * @param getNodeHandles - Function to get current node handles
 * @param setNodeHandles - Function to set node handles
 */

const hasHandlers = (
    module: any,
): module is { handlers: Record<string, string> } => {
    return module && typeof module === 'object' && 'handlers' in module;
};

export const addUnconnectedHandles = (
    dialog: BotMappieDialog | undefined,
    getNodeHandles: (nodeId: string) => string[],
    setNodeHandles: (nodeId: string, handles: string[]) => void,
): void => {
    if (!dialog || !dialog.modules) return;

    Object.entries(dialog.modules).forEach(([moduleId, module]) => {
        const currentHandles = getNodeHandles(moduleId) || [];
        const expectedHandles: string[] = [];

        if (hasHandlers(module)) {
            Object.keys(module.handlers).forEach((handlerKey) => {
                if (handlerKey.startsWith('on_')) {
                    const handle = handlerKey.substring(3);
                    if (!expectedHandles.includes(handle)) {
                        expectedHandles.push(handle);
                        expectedHandles.sort((a, b) => a.localeCompare(b));
                    }
                }
            });
        }

        if (
            expectedHandles.length > 0 &&
            (currentHandles.length === 0 ||
                !expectedHandles.every((h) => currentHandles.includes(h)))
        ) {
            const sortedHandles = [...expectedHandles].sort((a, b) =>
                a.localeCompare(b),
            );
            setNodeHandles(moduleId, sortedHandles);
        }
    });
};
